import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import {
  extractChecklistItemIdsFromProtocolForm,
  readProtocolItemCommentFromForm,
} from 'shared/domain/protocolAnswer/formKeys';
import { ComplianceCheckOutDto } from 'shared/dtos/out/complianceCheck';
import { ProtocolOutDtoWithChecklistId } from 'shared/dtos/out/inspection';
import { HashMap } from 'shared/types/commonView';

function complianceUnset(): ComplianceCheckOutDto {
  return {
    result: ComplianceAnswerOption.unset,
  };
}

/**
 * Builds protocol items for submit from flat form keys.
 * Collects checklist item ids from all answer/comment key shapes (legacy + PT-6687).
 */
export function protocolItemsFromForm(
  form: HashMap<unknown>
): ProtocolOutDtoWithChecklistId[] {
  const checklistItemIds = extractChecklistItemIdsFromProtocolForm(form);

  return checklistItemIds.map((checklistId) => ({
    checklistId,
    complianceCheck: {
      ...complianceUnset(),
      comment: readProtocolItemCommentFromForm(form, checklistId),
    },
  }));
}
